import { ContactPageTypes,  MetaTagsProps} from "@/types";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";

export const metaTagsContact : MetaTagsProps = {
    title: `Contact Us - ${BUSINESS_NAME}`,
    description: `Get in touch with ${BUSINESS_NAME}, trusted Sydney electricians specialising in residential, commercial, and solar services. Call us today or request a free quote online.`,
    keywords: "Powered Up Electrical contact, contact electricians Sydney, electrical quotes Sydney, solar quotes Sydney, emergency electrician Sydney, Sydney electrical services",
    url: `${WEBSITE_URL}/contact`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const contactPageContent : ContactPageTypes = {
    title: `Contact Us - ${BUSINESS_NAME}`,
    description: `Get in touch with ${BUSINESS_NAME}, trusted Sydney electricians specialising in residential, commercial, and solar services. Call us today or request a free quote online.`,
    images: [],
}
